import React, { useState } from 'react';

// Import de Bootstrap
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Row, Col } from 'react-bootstrap';

// Import del CSS 
import './Formulario.css';

function Formulario() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [fono, setFono] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);

const handleSubmit = (e) => {
  e.preventDefault();
  if (!name || !email || !fono) {
    alert('Por favor, complete todos los campos');
    return;
  }

const telefonoValido = /^\d{6,15}$/;

if (!telefonoValido.test(fono)) {
  alert("Por favor ingresa un número de teléfono válido con código internacional (Ej: 912345678). Solo se permiten números.");
  return;
};


  fetch('/Nilfisk.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      nombre: name,
      correo: email,
      telefono: fono,
      requerimientos: {
        demostracion: selecciones.demostracion,
        cotizacion: selecciones.cotizacion,
        servicio: selecciones.servicio,
        otros: selecciones.otros,
        texto_otros: selecciones.otros ? otroTexto : ""
      }
    }),
  })
  .then((response) => {
    if (!response.ok) {
      throw new Error('Error en la solicitud');
    }
    return response.json();
  })
  .then((data) => {
    console.log('Datos enviados:', data);
    setName('');
    setEmail('');
    setFono('');
    setIsChecked(false);
    setSelecciones({
      demostracion: false,
      cotizacion: false,
      servicio: false,
      otros: false
    });
    setOtroTexto('');
    setSuccessMessage(true);

    setTimeout(() => setSuccessMessage(false), 4000);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
};



  //Formulario con opciones
  const [selecciones, setSelecciones] = useState({
    demostracion: false,
    cotizacion: false,
    servicio: false,
    otros: false,
  });

  const [otroTexto, setOtroTexto] = useState("");

  const handleChange = (tipo) => {
    if (tipo === "otros") {
      // Si se selecciona "otros", desmarcar los otros y activar solo "otros"
      setSelecciones({
        demostracion: false,
        cotizacion: false,
        servicio: false,
        otros: true,
      });
    } else {
      // Si se selecciona alguno de los primeros 3, desactivar "otros"
      setSelecciones((prev) => ({
        ...prev,
        [tipo]: !prev[tipo],
        otros: false,
      }));
      setOtroTexto(""); // Limpiar texto si se desactiva "otros"
    }
  };

  return (
    <section className="container-fluid bg-image mb-5">
      <div className="container">
        <div className="row justify-content-md-end">
          <div className="col-md-auto"></div>
          <div className="col col-md-8 col-lg-6">
            <h2 className="Contacto RobotoBold">
              <strong>Contáctenos</strong>
            </h2>
            <div>
              <Form onSubmit={handleSubmit}>
                <FloatingLabel controlId="nombre" label="Nombre" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Ingresa tu nombre"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </FloatingLabel>

                <FloatingLabel controlId="email" label="Correo electrónico" className="mb-3">
                  <Form.Control
                    type="email"
                    placeholder="name@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </FloatingLabel>

                <FloatingLabel controlId="fono" label="Teléfono de Contacto" className="mb-3">
                  <Form.Control
                    type="tel"
                    placeholder="912345678"
                    value={fono}
                    onChange={(e) => setFono(e.target.value)}
                  />
                </FloatingLabel>

                <Row>
                  <Col className='col-12 text-start mb-2'>
                    <label><strong>Envíenos su Requerimiento</strong></label>
                  </Col>
                </Row>

                <Form.Check
                  type="checkbox"
                  label="Demostración de equipo"
                  checked={selecciones.demostracion}
                  onChange={() => handleChange("demostracion")}
                />
                <Form.Check
                  type="checkbox"
                  label="Cotización"
                  checked={selecciones.cotizacion}
                  onChange={() => handleChange("cotizacion")}
                />
                <Form.Check
                  type="checkbox"
                  label="Servicio Técnico"
                  checked={selecciones.servicio}
                  onChange={() => handleChange("servicio")}
                />
                <Form.Check
                  type="checkbox"
                  label="Otros"
                  checked={selecciones.otros}
                  onChange={() => handleChange("otros")}
                />

                {selecciones.otros && (
                  <Form.Group className="mt-2 text-start">
                    <Form.Label>Por favor, especifica</Form.Label>
                    <textarea
                      className="form-control"
                      type="text"
                      placeholder="Escribe tu requerimiento"
                      value={otroTexto}
                      onChange={(e) => setOtroTexto(e.target.value)}
                      rows={4}
                    />
                  </Form.Group>
                )}

                <Form.Group as={Row} className="mb-3 mt-3">
                  <Col className="text-start" sm={{ span: 12 }}>
                    <Form.Check
                      type="checkbox"
                      label="Al enviar este formulario, usted acepta que Nilfisk y los miembros del Grupo Nilfisk puedan comunicarse con usted por correo electrónico acerca de sus empresas, productos y servicios a través de comunicaciones de marketing directo."
                      checked={isChecked}
                      onChange={(e) => setIsChecked(e.target.checked)}
                    />
                  </Col>
                </Form.Group>

                <Button
                  className="w-100 btn-primary"
                  variant="info"
                  type="submit"
                  size="lg"
                  disabled={!isChecked}
                >
                  Enviar
                </Button>

                {successMessage && (
                  <div className="alert alert-success mt-3 text-center">
                    <strong>Mensaje enviado</strong>
                  </div>
                )}
              </Form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Formulario;